import { SportsType } from '../../catalog/enums/SportsType';
import { db } from '../FirebaseLibrary';

export const createPreDevelopedSeasonsReference = () => {
    return db.collection('pre-developed-seasons');
};

export const createPreDevelopedSeasonReference = (seasonId: string) => {
    return createPreDevelopedSeasonsReference().doc(seasonId);
};

// Pre-developed seasons are platform-wide and change about once a year, yet the app shell, season
// pages and team stats each read them one by one. Kept for the page's lifetime; a failed read is
// dropped so the next caller retries.
const preDevelopedSeasonReads = new Map<string, Promise<any>>();

export const fetchPreDevelopedSeasonFirestoreAPI = (seasonId: string) => {
    const hit = preDevelopedSeasonReads.get(seasonId);
    if (hit) return hit;
    const read = createPreDevelopedSeasonReference(seasonId).get();
    preDevelopedSeasonReads.set(seasonId, read);
    read.catch(() => { preDevelopedSeasonReads.delete(seasonId); });
    return read;
};

export const fetchPreDevelopedSeasonsFirestoreAPI = (sportsType: SportsType) => {
    return createPreDevelopedSeasonsReference().where('sportsType', '==', sportsType).orderBy('name').get();
};
